import { Component, OnInit, HostListener, EventEmitter, Output, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

export enum KEY_CODE {
  RIGHT_ARROW = 39,
  LEFT_ARROW = 37,
  UP_ARROW = 38,
  DOWN_ARROW = 40
}

export enum Circle {
  OUTER = 2,
  MID = 1,
  INNER = 3,
  NEW = 4
}

@Component({
  selector: 'app-vehicle-angles',
  templateUrl: './vehicle-angles.component.html',
  styleUrls: ['./vehicle-angles.component.less']
})
export class VehicleAnglesComponent implements OnInit, OnChanges {
  @Output() angleChange = new EventEmitter();
  stateFlag = false;
  @Input() firstCam = 1;
  @Input() folders;
  @Input() currentMode: string
  cameraSelected = 1;
  level = 0;
  touchScreen: boolean = false
  stateFlagCircle1 = false;
  stateFlagCircle2 = false;
  stateFlagCircle3 = false;
  stateFlagCircle4 = false;
  timer;
  timer2;
  timeTimer = 400; //seconds

  constructor(private deviceService: DeviceDetectorService) {
    this.touchScreen = (this.deviceService.isMobile() || this.deviceService.isTablet());
    this.stateFlagCircle1 = this.touchScreen.valueOf();
    this.stateFlagCircle2 = this.touchScreen.valueOf();
    this.stateFlagCircle3 = this.touchScreen.valueOf();
    this.stateFlagCircle4 = this.touchScreen.valueOf();
  }

  @Input() way = true;
  /* Defines matrix to transform angle number to actual camera number
     First element if each array is just an offset (-1) not
     an actual value
   * First array in each matrix is for way=false (transform[0=false])
   * Second one is for way=true (transform[1=true])*/
  _transformCamera = [
    [-1,
      10, 4, 1, 7,
      11, 5, 2, 8,
      12, 6, 3, 9,
      16, 14, 13, 15],
    [-1,
      1, 7, 10, 4,
      2, 8, 11, 5,
      3, 9, 12, 6,
      13, 15, 16, 14]
  ];
  _invertedTransformCamera = [
    [-1,
      3, 7, 11, 2,
      6, 10, 4, 8,
      12, 1, 5, 9,
      15, 14, 16, 13],
    [-1,
      1, 5, 9, 4,
      8, 12, 2, 6,
      10, 3, 7, 11,
      13, 16, 14, 15]
  ];

  ngOnInit() {
    this.cameraSelected = this.transformationAngleInverse(this.firstCam);
    this.giveLevel();
  }

  ngOnChanges(changes: SimpleChanges) {
    /* Refresh active angle if way changes
     ? Happens at init time when way is not provided by TchekAnimation yet */
    //  console.log('changes',changes);
    if (changes.way && changes.way.currentValue !== undefined)
      this.ngOnInit();
    if (changes.firstCam && changes.firstCam.currentValue !== undefined)
      this.ngOnInit();
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {

    if (event.keyCode === KEY_CODE.RIGHT_ARROW) {
      if (this.currentMode === 'video')
        this.goLeft();
      else
        this.angleChange.emit(1);
    } else if (event.keyCode === KEY_CODE.LEFT_ARROW) {
      if (this.currentMode === 'video')
        this.goRight();
      else
        this.angleChange.emit(-1);
    } else if (event.keyCode === KEY_CODE.UP_ARROW) {
      if (this.currentMode === 'video')
        this.goUp();
    } else if (event.keyCode === KEY_CODE.DOWN_ARROW) {
      if (this.currentMode === 'video')
        this.goDown();
    }
  }
  goUp() {
    this.cameraSelected = this.cameraSelected + 4;
    if ((this.cameraSelected > 12 && this.folders < 16) || (this.cameraSelected > 16)) {
      this.cameraSelected = this.cameraSelected % 4;
      if (this.cameraSelected == 0) this.cameraSelected = 4;
    }

    this.giveLevel();
    this.resetTimer();
    this.getNewCamera();
  }

  goDown() {
    this.cameraSelected = this.cameraSelected - 4;
    if (this.cameraSelected <= 0) {
      this.cameraSelected = this.cameraSelected + (this.folders >= 16 ? 16 : this.folders);
    }
    this.giveLevel();
    this.resetTimer();
    this.getNewCamera();
  }

  goLeft() {
    this.cameraSelected--;
    if (this.cameraSelected == 0 + (this.level - 1) * 4) {
      this.cameraSelected = 4 + (this.level - 1) * 4;
    }
    this.resetTimer();
    this.getNewCamera();
  }
  goRight() {
    this.cameraSelected++;
    if (this.cameraSelected == (this.level) * 4 + 1) {
      this.cameraSelected = this.cameraSelected - 4;
    }
    this.resetTimer();
    this.getNewCamera();
  }
  resetCircle() {
    if (this.touchScreen === false) {
      this.stateFlagCircle4 = false;
      this.stateFlagCircle3 = false;
      this.stateFlagCircle2 = false;
      this.stateFlagCircle1 = false;
    }

    if (this.level == 1) {
      this.stateFlagCircle3 = true;
    } else if (this.level == 2) {
      this.stateFlagCircle1 = true;
    } else if (this.level == 3) {
      this.stateFlagCircle2 = true;
    } else if (this.level == 4)
      this.stateFlagCircle4 = true
  }
  resetTimer() {
    if (this.stateFlag) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.stateFlag = !this.stateFlag;
      }, this.timeTimer * 1000);
    }
  }
  toggleState() {
    this.stateFlag = !this.stateFlag;

    this.resetCircle();
    if (this.stateFlag) {
      this.resetTimer();
    } else {
      clearTimeout(this.timer2);
      clearTimeout(this.timer);
    }
  }
  choiceAngle(angle, event) {
    if (!this.stateFlag) angle = angle + (this.level - 1) * 4;
    this.cameraSelected = angle;
    this.giveLevel();
    this.getNewCamera();
    event.stopPropagation();
    if (this.stateFlag) {
      clearTimeout(this.timer2);
      clearTimeout(this.timer);
      this.timer2 = setTimeout(() => {
        this.toggleState();
      }, 200);
    } else {
      clearTimeout(this.timer2);
    }
  }

  giveLevel() {
    this.level = 1;
    if (this.cameraSelected > 4 && this.cameraSelected < 9) {
      this.level = 2;
    } else if (this.cameraSelected > 8 && this.cameraSelected < 13) {
      this.level = 3;
    } else if (this.cameraSelected > 12)
      this.level = 4;
  }

  classesForAngle(angle: number) {
    if (angle >= 13) { // New
      return {
        'isVisible': !this.stateFlag ? false : this.stateFlagCircle4,
        'isSelected': this.cameraSelected == angle
      };
    } else if (angle >= 9) { // OUTER
      return {
        'isVisible': !this.stateFlag ? false : this.stateFlagCircle2,
        'isSelected': this.cameraSelected == angle
      };
    } else if (angle >= 5) { // MID
      return {
        'isVisible': !this.stateFlag ? false : this.stateFlagCircle1,
        'isSelected': this.cameraSelected == angle
      };
    } else { // INNER
      return {
        'isVisible': !this.stateFlag ? true : this.stateFlagCircle3,
        'isSelected': !this.stateFlag ? this.isSelected(angle) : this.cameraSelected == angle
      };
    }
  }
  isSelected(index) {
    let val = this.cameraSelected % 4;
    if (val == 0) val = 4;
    if (index == val)
      return true;
    else
      return false;

  }
  circleHover(index) {
    this.resetTimer();
    if (this.touchScreen === false) {
      this.stateFlagCircle1 = false;
      this.stateFlagCircle2 = false;
      this.stateFlagCircle3 = false;
      this.stateFlagCircle4 = false;
    }

    if (index == 1) {
      this.stateFlagCircle1 = true;
    } else if (index == 2) {
      this.stateFlagCircle2 = true;
    } else if (index == 3) {
      this.stateFlagCircle3 = true;
    } else if (index == 4) {
      this.stateFlagCircle4 = true;
    }
  }
  getNewCamera() {
    this.angleChange.emit(this.transformationAngle(this.cameraSelected));
  }

  transformationAngleInverse(angle: number) {
    // console.log('a way', this.way, 'got camera ', angle, 'sets', this._invertedTransformCamera[this.way ? 1 : 0][angle]);
    return this._invertedTransformCamera[this.way ? 1 : 0][angle];
  }


  transformationAngle(angle: number) {
    // console.log('way', this.way, 'want angle ', angle, 'got', this._transformCamera[this.way ? 1 : 0][angle]);
    return this._transformCamera[this.way ? 1 : 0][angle];
  }
}



// WEBPACK FOOTER //
// ./src/app/element/vehicle-angles/vehicle-angles.component.ts